/* eslint-disable */
import React, { Component } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import GolferApi from "../../../../services/golfer-api";
import RegisterErrorModal from "../../../../shared/components/modals/RegisterErrorModal";

class Password extends Component {
  state = {
    expanded: false,
    displayError: false,
    errorMessage: "",
  };

  onToggleExpand = () =>
    this.setState((prevState) => ({ expanded: !prevState.expanded }));

  onCloseModal = () => {
    this.setState({ displayError: false, errorMessage: "" });
  };

  updatePassword = async (values, { setSubmitting, resetForm }) => {
    const payload = {
      current_password: values.currentPassword,
      new_password: values.newPassword,
      new_password_confirmed: values.confirmPassword,
    };

    GolferApi.resetPassword(payload)
      .then((r) => {
        if (r && r.status === 200) {
          this.setState({
            displayError: true,
            errorMessage: "Your password was updated.",
          });
          resetForm();
        } else {
          this.setState({
            displayError: true,
            errorMessage:
              (r && r.data && r.data.error) || "An unexpected error occurred.",
          });
        }
      })
      .catch((err) => {
        this.setState({
          displayError: true,
          errorMessage:
            (err.response && err.response.data && err.response.data.error) ||
            "An unexpected error occurred.",
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  render() {
    const { expanded, displayError, errorMessage } = this.state;

    return (
      <div className="accordion-item">
        <RegisterErrorModal
          isOpen={displayError}
          onAbort={this.onCloseModal}
          onConfirm={this.onCloseModal}
          validationMessage={errorMessage}
        />

        <div
          className={"accordion-item__head " + (expanded ? "is-open" : "")}
          onClick={this.onToggleExpand}
        >
          <div className="p-row">
            <div className="l-col">
              <span className="accordion-item__label">Change Password</span>
            </div>
          </div>
        </div>
        <div className={"accordion-item__body " + (expanded ? "is-open" : "")}>
          <Formik
            initialValues={{
              currentPassword: "",
              newPassword: "",
              confirmPassword: "",
            }}
            validationSchema={Yup.object({
              currentPassword: Yup.string().required(
                "Current password is required"
              ),
              newPassword: Yup.string().required("New password is required"),
              confirmPassword: Yup.string()
                .oneOf([Yup.ref("newPassword"), null], "New passwords did not match.")
                .required("Confirmation of new password is required"),
            })}
            onSubmit={this.updatePassword}
          >
            {({ handleSubmit, isSubmitting, isValid, errors, touched }) => (
              <form onSubmit={handleSubmit}>
                <div className="p-row">
                  <div className="l-col blank"></div>
                  <div className="r-col">
                    <div className="row">
                      <div className="col">
                        <label>Current Password</label>
                        <Field
                          className="large"
                          type="password"
                          name="currentPassword"
                        />
                        {touched.currentPassword && errors.currentPassword && (
                          <span className="error">
                            {errors.currentPassword}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>New Password</label>
                        <Field
                          className="large"
                          type="password"
                          name="newPassword"
                        />
                        {touched.newPassword && errors.newPassword && (
                          <span className="error">{errors.newPassword}</span>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Confirm New Password</label>
                        <Field
                          className="large"
                          type="password"
                          name="confirmPassword"
                        />
                        {touched.confirmPassword && errors.confirmPassword && (
                          <span className="error">
                            {errors.confirmPassword}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <button
                          type="button"
                          onClick={this.onToggleExpand}
                          className="btn blank zero-pad blue"
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="col">
                        <button
                          type="submit"
                          className="btn fill cardinal"
                          disabled={!isValid || isSubmitting}
                        >
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}

export default Password;
